import React from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent';
import {getDeviceNameByType} from '@/services/device/deviceData';
import appRouterService from '@/services/route/appRouterService';
import {formatString} from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

const ConnectionFinishedContent = ({className, deviceType}) => {
    const {icon, title, description} = appContent.getConnectionFinished();
    const deviceName = getDeviceNameByType(deviceType);

    return (
        <div className={twx('flex flex-col items-center gap-4', className)}>
            <RemoteIconV2 icon={icon} className='h-16 w-16 shrink-0' />
            <h1 className='mb-0 text-28'>{formatString(title, deviceName)}</h1>
            <p>{formatString(description, deviceName)}</p>
        </div>
    );
};

const ConnectionPersonalizeButton = ({primary, className}) => {
    const {redirectButton} = appContent.getConnectionFinished();

    if (!redirectButton) {
        return null;
    }

    const {text, alt} = redirectButton;

    return (
        <AppButton
            className={twx('m-0', className)}
            primary={primary}
            secondary={!primary}
            light
            aria-label={alt}
            onClick={() => appRouterService.forwardToDevicesPage(true)}
        >
            {text}
        </AppButton>
    );
};

const ConnectionLearnHowToUseButton = ({className, onOpenQsg}) => {
    const {tipsButton} = appContent.getConnectionFinished();

    if (!tipsButton) {
        return null;
    }

    const {text, alt} = tipsButton;

    return (
        <AppButton className={twx('m-0', className)} primary light onClick={onOpenQsg} aria-label={alt}>
            {text}
        </AppButton>
    );
};

const ConnectionFinishedButtons = ({className, onOpenQsg}) => {
    return (
        <div className={twx('flex w-full flex-col gap-4', className)}>
            <ConnectionLearnHowToUseButton onOpenQsg={onOpenQsg} />
            <ConnectionPersonalizeButton />
        </div>
    );
};

ConnectionFinishedContent.Buttons = ConnectionFinishedButtons;
ConnectionFinishedContent.PersonalizeButton = ConnectionPersonalizeButton;

export default ConnectionFinishedContent;
